module.exports = __webpack_public_path__ + "static/media/vod19.fdef17d4.png";